// This icon file is generated automatically.
var PRightCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M9.42 6.9L5.57 4.12a.13.13 0 00-.2.1v.73c0 .16.08.31.21.4L7.85 7 5.58 8.64a.5.5 0 00-.2.4v.74c0 .1.11.16.2.1L9.41 7.1a.13.13 0 000-.2z" } }, { "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8z" } }] }] }, "name": "p-right-circle", "theme": "outlined" };
export default PRightCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PRightCircleOutlined.js
// module id = 3599
// module chunks = 0